<template>
  <d-modal
    size="lg"
    class="big-popup"
    @close="canClosePopup ? closePopup() : null">
    <d-modal-header>
      <d-modal-title>
        {{ $t('contractor.listOfContractorsWorksToBeSettled') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <contractors-settlements
        :dashboardParam="dashboardParam" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import ContractorsSettlements from './ContractorsSettlements.vue';

export default {
  name: 'contractors-settlements-popup',
  props: [
    'canClosePopup',
    'dashboardParam'
  ],
  components: {
    'contractors-settlements': ContractorsSettlements
  },
  methods: {
    closePopup () {
      this.$bus.$emit('dashboard-contractors-settlements-popup-close');
    }
  }
}
</script>
